import { z } from 'zod';
import { organizationGroupSlugSchema } from './organization-group-slug.js';
import { systemDisplayNameSchema } from './system-display-name.js';
/**
 * Group display-name schema.
 *
 * Rules (validated in this order):
 *   1. `.trim()` — strip leading/trailing whitespace BEFORE the length check
 *      so that `'   '` becomes `''` and fails `.min(1)`, while `'  Acme  '`
 *      becomes `'Acme'` and passes.
 *   2. `.min(1)` — non-empty after trim.
 *   3. `.max(200)` — display-name max length.
 *   4. `.refine(...)` — reject ASCII control characters (C0 range U+0000–U+001F
 *      plus DEL U+007F). This catches null bytes, CR, LF, vertical tab, form
 *      feed, and all other control characters that have no place in a display
 *      string and could be used for log-injection or terminal-escape attacks.
 *
 * Implementation note: the control-character rejection is implemented as a
 * `.refine()` with a `charCodeAt` loop rather than a regex literal. ESLint's
 * `no-control-regex` rule disallows regex literals that reference U+0000–U+001F
 * or U+007F via any escape form, and project policy forbids inline lint
 * suppressions. The character-by-character scan is behaviorally equivalent
 * to the negated character class `[^\u0000-\u001F\u007F]+` applied to the
 * entire (already-trimmed, already-non-empty) string.
 */
// SCRUM-312: now the shared systemDisplayName schema (max 200) so ISA + MSA
// "System Names" validate identically before the SystemName VO + the global
// uniqueness registry. Behaviour-identical to the prior inline definition.
const groupNameSchema = systemDisplayNameSchema(200);
export const createGroupSchema = z.object({
    slug: organizationGroupSlugSchema,
    name: groupNameSchema,
});
export const updateGroupSchema = z.object({
    name: groupNameSchema,
});
export const addExistingChildSchema = z.object({
    organizationId: z.string().uuid(),
});
//# sourceMappingURL=organization-group.js.map